export const PRINT_SERIF = '"Libre Baskerville", "Times New Roman", Times, serif';

export async function printDocument() {
  try {
    await Promise.all([
      document.fonts.load('400 13px "Libre Baskerville"'),
      document.fonts.load('500 13px "Libre Baskerville"'),
      document.fonts.load('700 13px "Libre Baskerville"'),
    ]);
    await document.fonts.ready;
  } catch {
    // Print anyway if a font file fails to load.
  }
  window.print();
}
